import { Clock } from "lucide-react";
import { daysUntil } from "@/lib/api";

export const DeadlineBadge = ({ deadline }) => {
  const days = daysUntil(deadline);
  if (days === null) return null;
  if (days < 0) {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider bg-zinc-200 text-zinc-500 px-2 py-1" data-testid="deadline-badge">
        <Clock size={10} /> Closed
      </span>
    );
  }
  const urgent = days <= 2;
  const soon = days <= 7;
  const cls = urgent
    ? "bg-[#C0392B] text-white"
    : soon
    ? "bg-[#FF8C00] text-white"
    : days <= 14
    ? "bg-amber-100 text-amber-900 border border-amber-200"
    : "bg-zinc-100 text-zinc-600 border border-zinc-200";
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 ${cls}`} data-testid="deadline-badge">
      <Clock size={10} /> {days === 0 ? "Closes today" : `Closes in ${days}d`}
    </span>
  );
};
